import React, { useEffect, useState, useRef } from 'react';

import { useDispatch } from 'react-redux';
import { changeBody, summaryWeight } from '../../../modules/tower/towerWriteSlice';

import { Input, Select } from '../TowerEditor';

import { getItemTotalWeight } from './weightSummary';

const OpeningForm = ({ openings, size, floors }) => {
    const dispatch = useDispatch();

    const width = parseFloat(size?.main?.width || 0);
    const length = parseFloat(size?.main?.length || 0);
    // const height = parseFloat(size?.main?.height || 0);

    // 전체 Floor 수 가져오기
    // const floorQty = Object.values(floors ? floors : {}).reduce((accumulator, currentValue) => accumulator + currentValue.qty ? currentValue.qty : 0, 0);
    const floorQty = Object.values(floors || {}).reduce(
        (accumulator, currentValue) => accumulator + (parseInt(currentValue.qty) || 0),
        0,
    );

    /*  Window, Louver, Door, BigDoor 수량 기준
    1) Window 및 Louver
    (floor수 + 1(지상)) x (roundup(width / 4m) + roundup(length / 4m))
    2) Door
    (floor수 + 1(지상)) x 2개
    3) BidDoor : 1개
    */

    const typesRef = useRef(['door', 'window', 'louver', 'bigDoor']);

    const [newOpening, setNewOpening] = useState(
        openings || {
            door: {
            },
            window: {
            },
            louver: {
            },
            bigDoor: {
            },
        },
    );

    const handleChange = (e) => {
        const { name, value } = e.target;
        const splitted = name.split('.');
        const category = splitted[0];
        const key = splitted[1];

        setNewOpening((prev) => ({
            ...prev,
            [category]: {
                ...prev[category],
                [key]: value,
            },
        }));
    };

    /* 수량 계산 */
    useEffect(() => {
        const calculateData = (category) => {
            let qty;
            // Type을 선택하지 않으면 화면에 수량이 나타나지 않도록 한다.
            if (!newOpening[category].type || newOpening[category].type === 'N/A') {
                qty = '';
                setNewOpening((prev) => ({
                    ...prev,
                    [category]: {
                        ...prev[category],
                        qty: qty || '',
                    },
                }));
                return;
            }
            // Type을 선택하면 수량을 계산한다.
            if (category === 'door') {
                qty = (parseInt(floorQty) + 1) * 2;
            } else if (category === 'window' || category === 'louver') {
                qty = (parseInt(floorQty) + 1) * (Math.ceil(width / 2 / 4) + Math.ceil(length / 2 / 4));
            } else {
                qty = 1;
            }

            setNewOpening((prev) => ({
                ...prev,
                [category]: {
                    ...prev[category],
                    qty: qty || '',
                },
            }));
        };

        typesRef.current.forEach((category) => {
            calculateData(category);
        });
    }, [floorQty, length, newOpening, width]);


    const openingUnitWeightMap = useRef({
        'door': 58,
        'window': 12.7,
        'louver': 5.7,
        'bigDoor': 600,
    })

    /* 단위 중량 산정 */
    useEffect(() => {
        const updateUnitWeight = (category) => {
            let unitWeight = 0;
            if (!newOpening[category]?.type || newOpening[category]?.type === 'N/A') {
                unitWeight = '';
            } else {
                unitWeight = openingUnitWeightMap.current[category];
            }

            setNewOpening(prev => ({
                ...prev,
                [category]: {
                    ...prev[category],
                    unitWeight,
                }
            }))
        }

        ['door', 'window', 'louver', 'bigDoor'].forEach(category => {
            updateUnitWeight(category);
        })
    }, [newOpening.door.type, newOpening.window.type, newOpening.louver.type, newOpening.bigDoor.type]);

    /* 중량 계산 */
    useEffect(() => {
        const calculateData = (category) => {
            const weight = Math.ceil(newOpening[category].qty * newOpening[category].unitWeight);

            setNewOpening((prev) => ({
                ...prev,
                [category]: {
                    ...prev[category],
                    weight: weight || '',
                },
            }));
        };
        typesRef.current.forEach((category) => {
            calculateData(category);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        newOpening.window.qty,
        newOpening.window.unitWeight,
        newOpening.louver.qty,
        newOpening.louver.unitWeight,
        newOpening.door.qty,
        newOpening.door.unitWeight,
        newOpening.bigDoor.qty,
        newOpening.bigDoor.unitWeight,
    ]);

    /* 리덕스에 weightSum 쓰기 */
    useEffect(() => {
        if (!newOpening) {
            return;
        }
        dispatch(
            summaryWeight({
                key: 'openings',
                value: getItemTotalWeight(newOpening),
            }),
        );
    }, [newOpening, dispatch]);

    /* 리덕스에 쓰기 */
    useEffect(() => {
        dispatch(
            changeBody({
                key: 'openings',
                value: newOpening,
            }),
        );
    }, [dispatch, newOpening]);

    return (
        <>
            <tr>
                <td>Openings</td>
            </tr>
            <tr>
                <td className="indentation">Door</td>
                <td colSpan={3} className="input-inside-td">
                    <Select name="door.type" value={newOpening.door.type} onChange={handleChange}>
                        <option value="" disabled hidden selected>
                            Select...
                        </option>
                        <option value="N/A">N/A</option>
                        <option value="Type-I">Type-I</option>
                        <option value="Type-II">Type-II</option>
                    </Select>
                </td>
                <td className="input-inside-td">
                    <Input name="door.qty" value={newOpening.door.qty} onChange={handleChange} />
                </td>
                <td>ea</td>
                <td className="right-align">{newOpening.door.unitWeight}</td>
                <td className="right-align">{newOpening.door.weight}</td>
            </tr>
            <tr>
                <td className="indentation">Window</td>
                <td colSpan={3} className="input-inside-td">
                    <Select name="window.type" value={newOpening.window.type} onChange={handleChange}>
                        <option value="" disabled hidden selected>
                            Select...
                        </option>
                        <option value="N/A">N/A</option>
                        <option value="Type-I">Type-I</option>
                        <option value="Type-II">Type-II</option>
                    </Select>
                </td>
                <td className="input-inside-td">
                    <Input name="window.qty" value={newOpening.window.qty} onChange={handleChange} />
                </td>
                <td>ea</td>
                <td className="right-align">{newOpening.window.unitWeight}</td>
                <td className="right-align">{newOpening.window.weight}</td>
            </tr>
            <tr>
                <td className="indentation">Louver</td>
                <td colSpan={3} className="input-inside-td">
                    <Select name="louver.type" value={newOpening.louver.type} onChange={handleChange}>
                        <option value="" disabled hidden selected>
                            Select...
                        </option>
                        <option value="N/A">N/A</option>
                        <option value="Type-I">Type-I</option>
                        <option value="Type-II">Type-II</option>
                    </Select>
                </td>
                <td className="input-inside-td">
                    <Input name="louver.qty" value={newOpening.louver.qty} onChange={handleChange} />
                </td>
                <td>ea</td>
                <td className="right-align">{newOpening.louver.unitWeight}</td>
                <td className="right-align">{newOpening.louver.weight}</td>
            </tr>
            <tr>
                <td className="indentation">Big Door</td>
                <td colSpan={3} className="input-inside-td">
                    <Select name="bigDoor.type" value={newOpening.bigDoor.type} onChange={handleChange}>
                        <option value="" disabled hidden selected>
                            Select...
                        </option>
                        <option value="N/A">N/A</option>
                        <option value="Type-I">Type-I</option>
                        <option value="Type-II">Type-II</option>
                    </Select>
                </td>
                <td className="input-inside-td">
                    <Input name="bigDoor.qty" value={newOpening.bigDoor.qty} onChange={handleChange} />
                </td>
                <td>ea</td>
                <td className="right-align">{newOpening.bigDoor.unitWeight}</td>
                <td className="right-align">{newOpening.bigDoor.weight}</td>
            </tr>
            <tr>
                <td className="spacer"></td>
            </tr>
        </>
    );
};

export default OpeningForm;
